<template>
  <div>
    <MainView />
    <Footer></Footer>
    <confirm ref="confirm"></confirm>
  </div>
</template>
<script>
import MainView from "../components/MainView";
import confirm from "../components/Reusable/Confirm.vue";
import Footer from "../components/footer.vue";

export default {
  name: "MainComponent",
  components: {
    MainView,
    confirm,
    Footer
  },
  data: () => ({}),
  methods: {},
  mounted() {},
  computed: {},
};
</script>
